<template>
  <FormTemplate>
    <template v-slot:form-body>
      <v-form ref="formDenunciationsQuestions" @submit.prevent="saveForm">
        <v-row>
          <v-col cols="12" md="2">
            <label for="title">Título de la sección</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-text-field
              id="title"
              v-model="denunciationsQuestions.title"
              outlined
              dense
              placeholder="Título"
              :rules="required"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <label for="file">Imagen</label>
          </v-col>
          <v-col cols="12" md="4" class="pb-0">
            <v-file-input
              id="file"
              v-model="file"
              outlined
              prepend-icon=""
              dense
              placeholder="Elige una imagen"
              @change="onFileNewChange"
            ></v-file-input>
          </v-col>
          <v-col cols="12">
            <div class="icon-cover section">
              <img draggable="false" :src="urlNew || loadImage(denunciationsQuestions.icon)" alt="icon - soborno" />
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <label for="content">Contenido</label>
          </v-col>

          <v-col cols="12" md="10" class="pb-0">
            <v-textarea
              id="content"
              v-model="denunciationsQuestions.content"
              outlined
              dense
              placeholder="Cargo del Funcionario"
              rows="5"
              :rules="required"
            ></v-textarea>
          </v-col>

          <v-col offset-md="3" cols="9">
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary"> Guardar </v-btn>
            <v-btn type="reset" @click="reset" class="mx-2" outlined> Limpiar </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormTemplate>
</template>

<script>
import FormTemplate from '@/components/forms/FormTemplate.vue'
import { loadAPIImage } from '@/utils/images'
import FormDenunciationsQuestions from '@/components/forms/FormDenunciationsQuestions.vue'
export default {
  components: {
    FormTemplate,
    FormDenunciationsQuestions,
  },
  props: {
    getDenunciationsQuestions: Function,
    loading: Boolean,
  },
  data() {
    return {
      required: [v => !!v || 'Requerido'],
      urlNew: '',
      file: null,
      denunciationsQuestions: {},
    }
  },
  async created() {
    this.denunciationsQuestions = await this.getDenunciationsQuestions()
  },
  methods: {
    validateForm() {
      return this.$refs.formDenunciationsQuestions.validate()
    },
    reset() {
      this.$refs.formDenunciationsQuestions.resetValidation()
    },
    saveForm() {
      if (!this.validateForm()) return
      let DTO = { ...this.denunciationsQuestions }

      if (this.file) {
        DTO = {
          ...DTO,
          file: this.file,
        }
      }

      // // console.log('actualizar', DTO)
      this.$emit('beforeUpdate', DTO)
    },
    onFileChange(e) {
      if (!e) return
      this.url = URL.createObjectURL(e)
    },
    onFileNewChange(e) {
      if (!e) return
      this.urlNew = URL.createObjectURL(e)
    },
    loadImage(src) {
      return loadAPIImage(src)
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-cover.section {
  display: flex;
  justify-content: center;
}
.icon-cover img {
  width: 150px;
  height: 80%;
  object-fit: cover;
  object-position: center;
}
.img-cover {
  height: 30vh;
  max-height: 400px !important;
  min-height: 250px !important;
  position: relative;
}

.img-cover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.img-cover .cover-title {
  width: 100%;
  position: absolute;
  bottom: 10%;
  color: white !important;
  font-size: 25px;
  margin-left: 10%;
  text-transform: uppercase;
}

.img-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.img-about {
  width: 100%;
}

.title-about {
  font-size: 25px;
  font-weight: 800;
  text-transform: uppercase;
}

.content-about {
  display: flex;
  align-items: center;
}

.text-about {
  white-space: pre-wrap;
  font-size: 14px;
}

.section {
  margin: 0 auto;
  max-width: 900px;
}
</style>
